export const USER_PANEL_PREF_KEY = 'user-panel:open-in-panel';

export interface PreferenceStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
}

function browserStorage(): PreferenceStorage | null {
    try {
        return typeof window === 'undefined' ? null : window.localStorage;
    } catch {
        return null;
    }
}

/** Per-browser opt-in for opening user links in the side panel. Defaults to off. */
export function readPanelPreference(storage: PreferenceStorage | null = browserStorage()): boolean {
    try {
        return storage?.getItem(USER_PANEL_PREF_KEY) === 'on';
    } catch {
        return false;
    }
}

export function writePanelPreference(on: boolean, storage: PreferenceStorage | null = browserStorage()): void {
    try {
        storage?.setItem(USER_PANEL_PREF_KEY, on ? 'on' : 'off');
    } catch {
        // Storage blocked (private mode, policy): the preference just stays at its default.
    }
}
